import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { makeRequest } from "../../../utils/axios.js";

export const useReport = (targetId, targetType, onClose) => {
    const [reason, setReason] = useState('');
    const [description, setDescription] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const reportMutation = useMutation({
        mutationFn: (reportData) => {
            return makeRequest.post('/reports', reportData);
        },
        onSuccess: () => {
            setTimeout(() => {
                handleClose();
            }, 2000);
        },
        onError: (error) => {
            setErrorMessage(error.response?.data || 'An error has occurred!');
        }
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!reason) {
            setErrorMessage('Please choose one reason!');
            return;
        }
        
        setErrorMessage('');
        reportMutation.mutate({ targetId, targetType, reason, description });
    };

    const handleClose = () => {
        setReason('');
        setDescription('');
        setErrorMessage('');
        reportMutation.reset(); 
        onClose();
    };

    return {
        reason,
        setReason,
        description,
        setDescription,
        errorMessage,
        handleSubmit,
        handleClose,
        isPending: reportMutation.isPending || reportMutation.isLoading,
        isSuccess: reportMutation.isSuccess
    };
};